export default "__VITE_ASSET__BSK6Slkp__"